import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";
import {
  MARKETPLACE_FAQS,
  BUYER_HOW_IT_WORKS,
  SELLER_HOW_IT_WORKS,
  ListingCheckoutTermsAndCondition,
  CreateListingTermsAndCondition,
} from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const TEAM_SCHEMA = "iowastatestudents_marketplace";

const MOBILE_LANDING_PAGE_STATIC_BANNER_URL =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Iowa%20State/Student%20Ticket%20Loop_375x550.png";
const LANDING_PAGE_STATIC_BANNER_URL =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Iowa%20State/Student%20Ticket%20Loop_1920x450.png";
const ORDER_SUMMARY_BACKGROUND_URL =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Iowa%20State/Student%20Ticket%20Loop2_1920x1080.png";

export const iowastatestudents_marketplace: TTeamConfig = {
  TEAM_SCHEMA: "iowastatestudents_marketplace",
  TEAM_FULL_NAME: "Iowa State University",
  BROWSER_TITLE: "Iowa State Student Marketplace",
  CLIENT_ID: "19a40b80a8b7.seasonshare.isu-isu.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,
  MARKETPLACE_VENDOR: constants.vendorUUIDs.stripe,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#C8102E",
    COLORS_SECONDARY: "#CAC7A7",
    DEFAULT_APP_ROUTE: routes.marketplace_home,
    DEFAULT_APP_ROUTE_AFTER_LOGIN: routes.marketplace_home,
    DEFAULT_APP_ROUTE_AFTER_LOGOUT: routes.marketplace_home,
    IS_MARKETPLACE_ENABLED: true,
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      HIDE_PURCHASE_HISTORY: true,
      HIDE_UPCOMING_EVENTS: true,
    },

    IS_INTERCOM_ENABLED: true,
  },

  MARKETPLACE_GLOBAL_SETTINGS: {
    BUYER_HOW_IT_WORKS,
    SELLER_HOW_IT_WORKS,
    FAQS: MARKETPLACE_FAQS(TEAM_SCHEMA),
    MARKETPLACE_REDIRECT_WARN_MODAL_DESCRIPTION:
      "You're entering a peer-to-peer marketplace where students can buy and sell tickets directly with each other. Prices are set by fellow students and are not regulated or controlled by Iowa State University.",
    STRIPE_KYC_CONFIRMATION_MODAL_DESCRIPTION:
      "Iowa State University and Attend use Stripe as a secure payment processor. You're about to leave this page to complete seller onboarding, where we'll collect your name, address, phone number, and bank details so we can deposit your payout once your ticket sells.",

    LISTING_CHECKOUT_TERMS_AND_CONDITION: <ListingCheckoutTermsAndCondition />,
    CREATE_LISTING_TERMS_AND_CONDITION: <CreateListingTermsAndCondition />,
  },

  MARKETPLACE_HOME_PAGE_SETTINGS: {
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    BECOME_SELLER_CARD: {
      TITLE: "Sell Your Student Ticket",
      DESCRIPTION:
        "Got a student ticket you can't use? Sell it to another student and make sure your seat is filled with school spirit. List your ticket in seconds and enjoy a quick, secure process that turns your unused ticket into extra cash.",
      BUTTON_TEXT: "Sell Your Ticket",
    },

    BECOME_BUYER_CARD: {
      TITLE: "Buy a Student Ticket",
      DESCRIPTION:
        "Looking for a ticket to the big game? Browse listings from fellow students and grab your seat in the student section. Enjoy a safe, hassle-free purchase and join your classmates in the action.",
      BUTTON_TEXT: "Browse Listings",
    },
  },

  MARKETPLACE_EVENTS_PAGE_SETTINGS: {
    PAGE_INFO_TEXT:
      "Click on a game to browse the available student tickets. After purchasing another student's ticket, your ticket with seat locations will be delivered within 2 hours to your Iowa State Account Manager.",
    CART: {
      MAX_LISTINGS_COUNT: 4,
    },
  },

  MARKETPLACE_THANK_YOU_PAGE_SETTINGS: {
    DESCRIPTION:
      "Your Iowa State University student ticket will be delivered within 2 hours of purchase in your Iowa State Account Manager.",
  },

  MARKETPLACE_CREATE_LISTING_PAGE_SETTINGS: {
    PAGE_INFO_TEXT:
      "List your student tickets for upcoming games and check back here to track their status. Only student tickets can be listed. Listings for each game will close two hours after kickoff on game day.",
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/NCAA/I-State_3Color.png",
    LANDING_PAGE_STATIC_BANNER_URL,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL,
    ORDER_SUMMERY_BACKGROUND_URL: ORDER_SUMMARY_BACKGROUND_URL,
    MARKETPLACE_HOME_PAGE_STATIC_BANNER_URL: LANDING_PAGE_STATIC_BANNER_URL,
  },

  LANGUAGES: {
    FAQS: [],
  },
};
